import * as actions from "./actionsTypes";

const initialData = {
  loaderPlazasVacantes: false,
  //loaderPlazaVacante: false,
  //saveLoaderPlazaVacante: false,
  plazasVacantes: null,
  //plazaVacante: null,
  plazasVacantesFalla: null,
  //plazaVacanteFalla: null,
  //formPlazaVacanteFalla: null
};

export default function PlazasVacantesReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADER_PLAZAS_VACANTES:
      return { ...state, loaderPlazasVacantes: action.payload };
    // case actions.LOADER_PLAZA_VACANTE:
    //   return { ...state, loaderPlazaVacante: action.payload };
    // case actions.SAVE_LOADER_PLAZA_VACANTE:
    //   return { ...state, saveLoaderPlazaVacante: action.payload };
    case actions.GET_PLAZAS_VACANTES:
      return {...state, plazasVacantes: action.payload};
    // case actions.GET_PLAZA_VACANTE:
    //   return {...state, plazaVacante: action.payload};
    case actions.PLAZAS_VACANTES_FALLA:
      return { ...state, plazasVacantesFalla: action.payload };
    // case actions.PLAZA_VACANTE_FALLA:
    //   return { ...state, plazasVacantesFalla: action.payload };
    // case actions.FORM_PLAZA_VACANTE_FALLA:
    //   return { ...state, formPlazaVacanteFalla: action.payload };
    default:
      return state;
  }
}
